import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';

import { AppConfigProvider } from './context/AppContextProvider';
import { UserContextProvider } from './context/UserContextProvider';

import store from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AppConfigProvider>
      <UserContextProvider>
        <App />
      </UserContextProvider>
    </AppConfigProvider>
  </Provider>
);
